import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';

@Component({
  selector: 'app-payment-status',
  imports: [RouterModule],
  templateUrl: './payment-status.component.html',
})
export class PaymentStatusComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private cdr = inject(ChangeDetectorRef);

  status: string | null = null;
  planId: string | null = null; // Pour le bouton "Réessayer"

  ngOnInit(): void {
    /**
     * DÉTAILS: Au chargement de cette page, l'utilisateur revient de Stripe.
     * L'URL contiendra des paramètres que nous avons définis dans la session de checkout côté backend.
     * On lit ces paramètres pour afficher le bon message.
     * Exemple de retour : /payment-status?status=success ou /payment-status?status=cancel&plan=pro
     */
    this.route.queryParams.subscribe((params) => {
      this.status = params['status'] || 'cancel'; // 'success' ou 'cancel'
      this.planId = params['plan'];
      this.cdr.markForCheck();
    });
  }
}
